export const TRAIT_MODE = {
	SELECTION: "selection",
	EXPLORE: "explore",
	JOINED_MATCH: "joined-match",
};
